import React, { Component } from 'react'
import {Link} from 'react-router-dom'
class EventBoxs2 extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dataEvents: [
                {
                    id: 4,
                    classicon: 'icon-rounded magic',
                    title: 'Data Analysis',
                    description: 'Comprehensive data analysis, validation, and evidence-based insights',
                },
                {
                    id: 5,
                    classicon: 'icon-rounded artboard',
                    title: 'Capacity Building',
                    description: 'Empowering teams with essential data skills through coaching',
                },
                {
                    id: 6,
                    classicon: 'icon-rounded global',
                    title: 'Strategic Consulting',
                    description: 'Actionable recommendations that drive organizational growth',
                },
            ]
        }
    }
    
    render() {
        return (
            <div className="row">
                {
                    this.state.dataEvents.map(data => (
                        <div className="col-lg-4 col-md-6 col-sm-12" key={data.id}>
                            <div className="iconbox-item" style={{ height: '100%' }}>
                                <div className="iconbox style1" style={{ background: '#ffffff', padding: '22px', height: '100%', textAlign: 'center', overflow: 'hidden' }}>
                                    <div className="box-header" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '12px' }}>
                                        <div className={data.classicon} style={{ position: 'static', width: '44px', height: '44px', background: '#62B6E8', margin: '0', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', color: '#fff' }}>
                                            {data.id === 4 && <i className="fa fa-database" style={{ fontSize: '18px' }}></i>}
                                            {data.id === 5 && <i className="fa fa-users" style={{ fontSize: '18px' }}></i>}
                                            {data.id === 6 && <i className="fa fa-briefcase" style={{ fontSize: '18px' }}></i>}
                                        </div>
                                        {/* <!-- /.icon-rounded --> */}
                                        <div className="box-title" style={{ marginTop: '6px', textAlign: 'left', flex: 1 }}>
                                            <Link to={`/services/${data.id}`} title="" style={{ fontWeight: 700 }}>{data.title}</Link>
                                        </div>
                                        {/* <!-- /.box-title --> */}
                                        </div>
                                    {/* <!-- /.box-header --> */}
                                    <div className="box-content" style={{ opacity: 0.9 }}>{data.description}</div>
                                    {/* <!-- /.box-content --> */}
                                </div>
                                 {/* <!-- /.iconbox --> */}
					    </div>
                            {/* <!-- /.iconbox-item --> */}
                        </div>
                    ))
                }
            </div>
        );
    }
}

export default EventBoxs2;
